import React, { RefObject, useCallback, useEffect, useState } from "react";
import Dialog from "./Dialog";
import Loading from "../Loading";
import ErrorView from "../../pages/ErrorView";
import { fetchLogsById } from "../../helpers/apiHelper";
import { useApiErrorHandler } from "../../hooks/useApiErrorHandler";
import { DerivedDialogProps } from "../../types/dialogTypes";
import { LogsResponse } from "../../types/statusTypes";
import AuditLogDialogBody from "./AuditLogDialogBody";

export default function AuditLogDialog({ assetId }: DerivedDialogProps) {
  const { loading, error, response, fetchData } = useApiErrorHandler<LogsResponse>();
  const [dialogRef, setDialogRef] = useState<RefObject<HTMLDivElement> | null>(null);

  const loadLogs = useCallback(() => {
    fetchData(fetchLogsById(assetId));
  }, [fetchData, assetId]);

  useEffect(loadLogs, [loadLogs]);

  useEffect(() => {
    if (!dialogRef?.current) return;
    dialogRef.current.addEventListener("show.bs.modal", loadLogs);
  }, [dialogRef, loadLogs]);

  const hasResponseAndLogs = response && response.length > 0;

  return (
    <Dialog
      id="audit-log-modal"
      isFullScreen={true}
      onRefChange={setDialogRef}
      headerText={`Audit Log - ${assetId}`}
      body={(
        <>
          {loading && <Loading />}
          {!loading && error && (
            <ErrorView message="Something went wrong. Please try again." hasHomeButton={false} />)}
          {!loading && !error && !hasResponseAndLogs && (
            <ErrorView message="No logs found for this asset" hasHomeButton={false} />)}
          {!loading && !error && hasResponseAndLogs && <AuditLogDialogBody logs={response} />}
        </>
      )}
    />
  );
}
